import { IsNotEmpty, IsObject, IsOptional, IsString } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { AttemptAnswers } from '../../../types/attempt-answers.types';

export class UpdateAttemptRequestDto {
  @ApiProperty({
    description: "ID de la tentative",
  })
  @IsString()
  @IsNotEmpty()
  id: string;

  @ApiPropertyOptional({
    description: "Réponses partielles ou complètes de l'utilisateur",
  })
  @IsOptional()
  @IsObject()
  userAnswers?: AttemptAnswers;

  @ApiPropertyOptional({
    description: "Métadonnées de l'interface (page courante, etc.)",
  })
  @IsOptional()
  @IsObject()
  metadata?: Record<string, any>;
}
